import { h } from '@stencil/core';
import { BADGE_TYPE_MAP } from './constants';
export class Badge {
  constructor() {
    this.type = undefined;
    this.color = undefined;
    this.label = undefined;
    this.size = 'small';
    this.lineHeight = undefined;
  }
  getBadgeType(type) {
    if (type in BADGE_TYPE_MAP) {
      return BADGE_TYPE_MAP[type];
    }
    return '';
  }
  render() {
    return (h("pes-badge", { type: this.getBadgeType(this.type), label: this.label, size: this.size, color: this.color, lineHeight: this.lineHeight }));
  }
  static get is() { return "pes-badge-wrapper"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["badge-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["badge-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Type of badge coming from backend"
        },
        "attribute": "type",
        "reflect": false
      },
      "color": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Color of badge coming from backend"
        },
        "attribute": "color",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label of badge"
        },
        "attribute": "label",
        "reflect": false
      },
      "size": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'large' | 'small'",
          "resolved": "\"large\" | \"small\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Size of badge"
        },
        "attribute": "size",
        "reflect": false,
        "defaultValue": "'small'"
      },
      "lineHeight": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Line height of badge"
        },
        "attribute": "line-height",
        "reflect": false
      }
    };
  }
}
